/* tslint:disable */
/* eslint-disable */
/**
 * Webclipping
 * WebclippingのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 過去記事検索結果でのページネーション用の情報
 * @export
 * @interface ArticlePastSearchV2Pager
 */
export interface ArticlePastSearchV2Pager {
    /**
     * 
     * @type {number}
     * @memberof ArticlePastSearchV2Pager
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ArticlePastSearchV2Pager
     */
    currentPage: number;
    /**
     * 
     * @type {number}
     * @memberof ArticlePastSearchV2Pager
     */
    lastPage: number;
    /**
     * 1ページあたりの表示件数。無料版は30件、有料版は50件。
     * @type {number}
     * @memberof ArticlePastSearchV2Pager
     */
    limit: number;
}

export function ArticlePastSearchV2PagerFromJSON(json: any): ArticlePastSearchV2Pager {
    return ArticlePastSearchV2PagerFromJSONTyped(json, false);
}

export function ArticlePastSearchV2PagerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArticlePastSearchV2Pager {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'currentPage': json['current_page'],
        'lastPage': json['last_page'],
        'limit': json['limit'],
    };
}

export function ArticlePastSearchV2PagerToJSON(value?: ArticlePastSearchV2Pager | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'current_page': value.currentPage,
        'last_page': value.lastPage,
        'limit': value.limit,
    };
}

